import {
  CLOSE_BOTH_TILES, CLOSE_TILE, CloseBothTiles,
  CloseTile,
  OPEN_TILE, OpenTile,
} from '../actions/informationTile';
import { EntriesStateType } from '../constants';
import { InformationTileState } from '../types/informationTile';

// ---

const initialState: InformationTileState = {
  openedActiveStakesTiles: new Set(),
  openedSidebarStakesTiles: new Set(),
};

type Action = OpenTile | CloseTile | CloseBothTiles;

// ---

function setNewTileValue(
  state: InformationTileState,
  action: OpenTile | CloseTile,
  key: keyof InformationTileState,
): InformationTileState {
  const openedTiles = new Set(state[key]);

  if (action.type === OPEN_TILE) {
    openedTiles.add(action.payload.id);
  }
  else if (action.type === CLOSE_TILE) {
    openedTiles.delete(action.payload.id);
  }

  return {
    ...state,
    [key]: openedTiles,
  };
}

// ---

export default function (state = initialState, action: Action): InformationTileState {
  switch (action.type) {
    case OPEN_TILE:
    case CLOSE_TILE: {
      const namespace = action.payload.namespace;

      if (namespace === EntriesStateType.ACTIVE) {
        return setNewTileValue(state, action, 'openedActiveStakesTiles');
      }

      if (namespace === EntriesStateType.SIDEBAR) {
        return setNewTileValue(state, action, 'openedSidebarStakesTiles');
      }

      return state;
    }

    case CLOSE_BOTH_TILES: {
      const activeTiles = new Set(state.openedActiveStakesTiles);
      const sidebarTiles = new Set(state.openedSidebarStakesTiles);

      activeTiles.delete(action.payload.id);
      sidebarTiles.delete(action.payload.id);

      return {
        ...state,
        openedActiveStakesTiles: activeTiles,
        openedSidebarStakesTiles: sidebarTiles,
      };
    }

    default:
      return state;
  }
}
